export default {
  de: {
    base: {
      appLoginName: 'Anmeldename',
      email: 'E-Mail',
      firstName: 'Vorname',
      lastName: 'Nachname',
      passwordSetSuccess: 'Passwort erfolgreich gesetzt',
      passwordSetError: 'Der Code existiert nicht oder wurde schon genutzt',
      password: 'Passwort',
      clock: 'Uhr',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      create: 'Erfassen',
      ok: 'Ok',
      close: 'Schließen',
      save: 'Speichern',
      continue: 'Weiter',
      finish: 'Abschließen',
      start: 'Start',
      hours: 'Stunden',
      minutes: 'Minuten',
      seconds: 'Sekunden',
      amount: 'Anzahl',
      percentage: 'Prozent',
      time: 'Zeit',
      note: 'Notiz',
      customer: 'Kunde',
      loading: 'Lade....',
      to: 'bis',
      updates: 'Beschreibungen und Updates',
      error_solved: 'Entstört'
    },
    login: {
      login_action: 'Anmelden',
      registration_heading: 'Anmeldung',
      registration_text: 'Bitte geben Sie Ihre Benutzerdaten ein',
      username_placeholder: 'Benutzernamen eingeben',
      password_placeholder: 'Passwort eingeben',
      username_label: 'Benutzername',
      password_label: 'Passwort',
      username_required: 'Der Benutzername wird benötigt!',
      password_required: 'Das Passwort wird benötigt!',
      failed_login_attempts: 'Der Login ist aufgrund der fehlerhaften Loginversuche gesperrt',
      continue: 'Weiter',
      back: 'Zurück',
      microsoft_login: 'Mit Microsoft anmelden',
      identify_error: 'Der Benutzer konnte nicht identifiziert werden',
      entra_login_error: 'Die Anmeldung mit Microsoft ist fehlgeschlagen',
    },
    password: {
      title: 'Erfolgreich',
      error: 'Fehler',
      heading: 'Neues Passwort setzen',
      text: 'Hier können Sie Ihr persönliches Kennwort für die experts4media ServiceApp einrichten. Das Kennwort muss mindestens 8 Zeichen lang sein. Und es muss mindestens drei von den folgenden vier Elementen enthalten: eine Ziffer, einen Großbuchstaben, einen Kleinbuchstaben, ein Sonderzeichen.',
      password_doesnt_match_guidelines: 'Das Passwort entspricht nicht den Kriterien',
      password: 'Passwort',
      passwordRepeat: 'Passwort wiederholen',
      save_password: 'Passwort speichern',
      check_password: 'Die Passwörter stimmen nicht überein',
      finished: 'Das Passwort wurde erfolgreich gespeichert. Bitte melden Sie sich in der App an.'
    },
    main: {
      logout: 'Ausloggen'
    },
    nav: {
      current_reports: 'Aktuelle Meldungen',
      new_report: 'Neue Meldung erstellen',
      report_categories: 'Report-Kategorien',
      customer_settings: 'Kundeneinstellungen',
      server_settings: 'Servereinstellungen',
      tenant_management: 'Mandantenverwaltung',
      global_overview: 'Globale Übersicht'
    },
    current_reports: {
      select_tenant: 'Mandant auswählen',
      select_tenant_info: 'Bitte wählen Sie einen Mandanten',
      select_tenant_description: 'Um Reports zu sehen, wählen Sie bitte zuerst einen Mandanten aus der Liste aus.',
      tenant_load_error: 'Fehler beim Laden der Mandanten',
      report_created: 'Mitteilung erstellt',
      report_last_updated: 'Letztes Update',
      report_creator: 'Ersteller',
      report_updater: 'Updater',
      report_done_dialog_title: 'Abschlussmeldung',
      report_done_dialog_help: 'Bitte geben Sie eine Abschlussmeldung ein:',
      report_extend_time_range_dialog_title: 'Grund der Verlängerung',
      report_extend_time_range_dialog_help: 'Bitte geben Sie den Grund der Verlängerung ein:',
      report_extend_time_range_default_reason: 'Die notwendigen Wartungsarbeiten dauern länger als erwartet. experts4media verlängert daher diese Maßnahme.',
      report_extend_time_range_readonly_hint: 'Der Startzeitpunkt kann nicht verändert werden, da die Wartung bereits aktiv ist'
    },
    report: {
      select_tenant: 'Mandanten auswählen',
      tenant_load_error: 'Fehler beim Laden der Mandanten',
      customer_load_error: 'Fehler beim Laden der Kunden',
      tenant_required: 'Bitte wählen Sie einen Mandanten aus',
      category_load_error: 'Fehler beim Laden der Kategorien'
    },
    report_categories: {
      title: 'Report-Kategorien',
      name: 'Name',
      type: 'Typ',
      level: 'Level',
      color: 'Farbe',
      priority: 'Priorität',
      visibility_duration: 'Sichtbarkeitsdauer',
      tenant: 'Mandant',
      actions: 'Aktionen',
      create: 'Kategorie erstellen',
      edit: 'Kategorie bearbeiten',
      delete: 'Kategorie löschen',
      refresh: 'Aktualisieren',
      search: 'Suchen...',
      hours: 'Stunden',
      days: 'Tage',
      select_tenant: 'Mandant auswählen',
      tenant_required: 'Mandant ist erforderlich',
      name_required: 'Name ist erforderlich',
      type_required: 'Typ ist erforderlich',
      level_required: 'Level ist erforderlich',
      create_success: 'Kategorie erfolgreich erstellt',
      create_error: 'Fehler beim Erstellen der Kategorie',
      update_success: 'Kategorie erfolgreich aktualisiert',
      update_error: 'Fehler beim Aktualisieren der Kategorie',
      delete_success: 'Kategorie erfolgreich gelöscht',
      delete_error: 'Fehler beim Löschen der Kategorie',
      delete_conflict_error: 'Diese Kategorie wird noch verwendet und kann daher nicht gelöscht werden. Entfernen Sie zuerst alle zugewiesenen Elemente, um die Kategorie zu löschen.',
      load_error: 'Fehler beim Laden der Kategorien',
      delete_confirm_title: 'Kategorie löschen',
      delete_confirm_content_with_reports: 'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?<br><br>Das Löschen wird <strong>{count}</strong> zugewiesene Meldung(en) unwiderruflich mit löschen!<br><br>Diese Aktion kann nicht rückgängig gemacht werden.',
      delete_confirm_content_no_reports: 'Sind Sie sicher, dass Sie diese Kategorie löschen möchten?<br><br>Es sind keine Meldungen zugewiesen.<br><br>Diese Aktion kann nicht rückgängig gemacht werden.'
    },
    new_report: {
      add_customer: 'Kunde hinzufügen',
      subject: 'Betreff',
      select_type: 'Kategorie auswählen',
      send_report: 'Senden',
      patch_report: 'Aktualisieren',
      delete_report: 'Löschen',
      delete_dialog_text: 'Soll die Meldung wirklich gelöscht werden?',
      subject_required: 'Geben Sie einen Betreff ein!',
      content_required: 'Geben Sie den Inhalt der Meldung ein!',
      update_required: 'Geben Sie den Inhalt des Updates ein!',
      category_required: 'Wählen Sie eine Kategorie aus!',
      customer_required: 'Wählen Sie einen Kunden aus!',
      start_point_of_time: 'Startzeitpunkt',
      end_point_of_time: 'Endzeitpunkt',
      time_range_required: 'Bitte geben Sie einen Wartungszeitraum an',
      time_range_duration_too_small: 'Bitte wählen Sie einen Zeitraum größer als 15 Minuten aus',
      report_created: 'Mitteilung erstellt',
      report_last_updated: 'Letztes Update',
      report_creator: 'Ersteller'
    },
    notification: {
      report_created_successfull: 'Erfolg',
      report_created_successfull_text: 'Die Meldung wurde erfolgreich gesendet!',
      report_patched_successfull: 'Erfolg',
      report_patched_successfull_text: 'Die Meldung wurde erfolgreich aktualisiert!',
      report_update_created_successfull: 'Erfolg',
      report_update_created_successfull_text: 'Das Update wurde erfolgreich gesendet!',
      report_update_patched_successfull: 'Erfolg',
      report_update_patched_successfull_text: 'Das Update wurde erfolgreich aktualisiert!',
      login_error: 'Fehler',
      login_error_text: 'Der eingegebene Benutzername oder das Passwort ist falsch!',
      login_error_not_admin_text: 'Für die Anmeldung an diesem System müssen ADMIN-Rechte vorhanden sein!',
      mobil_alert: 'Diese Bildschirmgröße wird nicht unterstützt!'
    },
    settings: {
      synchronizedAccounts: 'Synchronisierte Accounts',
      adConnectionAdded: 'Verbindung erfolgreich hinzugefügt',
      adConnectionDeleted: 'Verbindung erfolgreich gelöscht',
      adConnectionUpdated: 'Verbindung erfolgreich aktualisiert',
      adConnectionCount: 'Anzahl Verbindungen',
      addConnection: 'Verbindung hinzufügen',
      noConnections: 'Keine Verbindungen vorhanden',
      ldapSubtitle: 'LDAP / Active Directory Verbindungen',
      addLdapServer: 'LDAP-Server hinzufügen',
      adColServer: 'Server',
      adColLoginDomain: 'Login-Domain',
      adColActive: 'Aktiv',
      connectionsSingular: 'Verbindung',
      connectionsPlural: 'Verbindungen',
      selectServer: 'Server wählen',
      connectionDialogSubtitle: 'LDAP-Quelle für diesen Kunden verknüpfen',
      dnPlaceholder: 'OU=Abteilung,DC=domain,DC=de',
      ldapEmptyTitle: 'Noch keine LDAP-Verbindung',
      ldapEmptySubtitle: 'Verknüpfe einen Verzeichnisdienst, um die Accounts dieses Kunden automatisch zu synchronisieren.',
      sectionEntra: 'Entra Einstellungen',
      noEntraConnections: 'Keine Entra-Verbindungen vorhanden',
      entraEmptyTitle: 'Noch kein Entra-Provider',
      entraEmptySubtitle: 'Verknüpfe eine Entra-Gruppe, um die Accounts dieses Kunden automatisch zu synchronisieren.',
      entraGroup: 'Gruppe',
      selectConnection: 'Verbindung wählen',
      selectGroup: 'Gruppe wählen',
      entraGroupSelectFirst: 'Zuerst eine Verbindung wählen',
      entraConnectionCreate: 'Verbindung erstellen',
      entraConnectionEdit: 'Verbindung bearbeiten',
      entraProviderDialogSubtitle: 'Entra-Quelle für diesen Kunden verknüpfen',
      entraConnectionAdded: 'Verbindung erfolgreich hinzugefügt',
      entraConnectionUpdated: 'Verbindung erfolgreich aktualisiert',
      entraConnectionDeleted: 'Verbindung erfolgreich gelöscht',
      entraDeleteConnectionTitle: 'Verbindung löschen',
      entraDeleteProviderInfoText: 'Bist du sicher, dass du diesen Entra-Provider löschen möchtest?',
      addEntraConnection: 'Entra Tenant hinzufügen',
      entraName: 'Name',
      entraNamePlaceholder: 'Name der Verbindung',
      entraTenantId: 'Entra-Tenant-ID',
      entraTenantNameColumn: 'Entra Tenant Name',
      entraTenantColumn: 'Entra Tenant',
      entraTenantIdHint: 'Die Tenant-ID aus dem Entra-Portal des Kunden',
      entraConsentUrlLabel: 'Admin-Zustimmungs-URL',
      entraConsentUrlLoading: 'Zustimmungs-URL wird geladen…',
      entraConnectionCreateSubtitle: 'Neue Verbindung zu einem Entra-Mandanten anlegen',
      entraConnectionEditSubtitle: 'Verbindung zum Entra-Mandanten bearbeiten',
      entraRegistrationTitle: 'App-Registrierung',
      entraRegistrationSubtitle: 'Die App-Registrierung bei Microsoft Entra',
      entraRegistrationUpdated: 'App-Registrierung erfolgreich aktualisiert',
      servers: 'Server',
      entraAppId: 'App-ID',
      entraClientSecret: 'Client-Secret',
      entraServerAdd: 'Entra Tenant hinzufügen',
      entraServerEdit: 'Entra Tenant bearbeiten',
      editLdapServerConnection: 'LDAP-Server-Verbindung bearbeiten',
      entraGroupSync: 'Gruppen synchronisieren',
      entraGroupSyncSuccess: 'Gruppen erfolgreich synchronisiert',
      entraGroupSyncSuccessCount: '{count} Gruppen erfolgreich synchronisiert',
      entraGroupSyncError: 'Die Gruppen konnten nicht synchronisiert werden.',
      entraErrors: {
        connectionAlreadyExists: 'Für diesen Entra-Tenant existiert bereits eine Verbindung.',
        providerAlreadyExists: 'Für diesen Kunden existiert bereits ein Provider mit dieser Verbindung und Gruppe.',
        registrationMissing: 'Es ist keine App-Registrierung hinterlegt. Bitte zuerst App-ID und Client-Secret speichern.',
        connectionFailed: 'Verbindung zu Microsoft Entra fehlgeschlagen. Bitte App-Registrierung und Tenant-ID prüfen.',
        validationFailed: 'Der Entra-Provider konnte nicht validiert werden. Bitte Verbindung und Gruppe prüfen.',
        notFound: 'Die Verbindung oder Gruppe wurde nicht gefunden. Bitte die Gruppen synchronisieren.',
        forbidden: 'Für diese Aktion fehlen dir die nötigen Rechte.',
        generic: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.'
      },
      changeWarning: {
        title: 'Achtung!',
        confirm: 'Ja, Änderung vornehmen',
        text: 'Diese Änderung betrifft {providers} und {accounts}. Beim nächsten Synchronisationsvorgang kann es dadurch zu Problemen kommen. Bist du dir sicher, dass du diese Änderung vornehmen willst?',
        providersSingular: '1 verknüpften Kunden',
        providersPlural: '{count} verknüpfte Kunden',
        accountsSingular: '1 synchronisierten Account',
        accountsPlural: '{count} synchronisierte Accounts'
      },
      entraRules: {
        connection: 'Bitte eine Verbindung auswählen',
        group: 'Bitte eine Gruppe auswählen',
        appId: 'Bitte die App-ID eingeben',
        clientSecret: 'Bitte das Client-Secret eingeben',
        tenantId: 'Bitte die Entra-Tenant-ID eingeben',
        name: 'Bitte einen Namen eingeben'
      },
      roleDescriptions: {
        USER: 'Meldungen einsehen',
        REPORTER: 'Meldungen erstellen',
        ADMIN: 'Voller Zugriff'
      },
      entries: 'Einträge',
      emailSentTo: 'E-Mail gesendet an {name}',
      pushSentTo: 'Push gesendet an {name}',
      accountStatusChangeError: 'Fehler beim Ändern des Account-Status',

      editTenant: 'Mandanten bearbeiten',
      selfTenantSettings: 'Mandanteneinstellungen',

      logo_upload_type_error: 'Bitte laden Sie nur Bilddateien hoch',
      logo_upload_size_error: 'Das Bild darf nicht größer als 2MB sein',
      logo_upload_success: 'Logo erfolgreich hochgeladen',
      logo_upload_error: 'Fehler beim Hochladen des Logos, bitte versuchen Sie es erneut',
      logo_preview: 'Logo-Vorschau',
      logo_remove: 'Logo entfernen',
      logo_upload: 'Logo hochladen',
      logo_drag: 'Ziehen Sie das Logo hierher oder klicken Sie zum Hochladen',

      accountRules: {
        firstName: 'Bitte Vorname eingeben',
        lastName: 'Bitte Nachname eingeben',
        email: 'Bitte E-Mail eingeben',
        appLoginName: 'Bitte Anmeldename eingeben',
        loginDomain: 'Bitte Login-Domain eingeben',
        noSpecialChars: 'Sonderzeichen nicht erlaubt'
      },
      customerRules: {
        name: 'Bitte Name eingeben',
        email: 'Bitte E-Mail eingeben',
        appLoginName: 'Bitte Domain während Login eingeben',
        user: 'Der LDAP-User muss angeben werden',
        password: 'Das LDAP-Passwort muss angeben werden',
        url: 'Die LDAP-URL muss angeben werden',
        role: 'Bitte eine Rolle auswählen'
      },
      nameRequired: 'Name ist erforderlich',
      firstNameRequired: 'Vorname ist erforderlich',
      lastNameRequired: 'Nachname ist erforderlich',
      emailRequired: 'E-Mail ist erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      appLoginNameRequired: 'Anmeldename ist erforderlich',
      adConnections: {
        create: 'Verbindung erstellen',
        edit: 'Verbindung bearbeiten',
        createSubtitle: 'Neuen LDAP-Server anbinden',
        editSubtitle: 'LDAP-Server-Verbindung anpassen',
        serverHint: 'Sichere Verbindung über LDAPS empfohlen (Port 636).',
        passwordEditHint: 'Zum Ändern anklicken — das alte Passwort wird verworfen.',
        newPasswordPlaceholder: 'Neues Passwort eingeben',
        testConnection: 'Verbindung testen',
        deleteConnectionTitle: 'Verbindung löschen',
        deleteConnectionInfoText: 'Bist du sicher, dass du die Verbindung löschen möchtest? Es sind {synced} Nutzer synchronisiert.',
        validationSuccess: 'Verbindung erfolgreich getestet',
        ldapServerErrors: {
          alreadyExists: 'Für diesen LDAP-Server existiert bereits eine Verbindung.',
          connectionFailed: 'Verbindung zum LDAP-Server fehlgeschlagen. Bitte überprüfen Sie URL, Domäne und Zugangsdaten.',
          noMatchingUser: 'Kein passender Benutzer im Verzeichnis gefunden.',
          generic: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.'
        }
      },
      tenantCreate: 'Mandant erstellen',
      tenantCreated: 'Mandant erfolgreich erstellt',
      tenantSection: 'Mandanteninformationen',
      addressSection: 'Adressinformationen',
      contactSection: 'Kontaktinformationen',
      description: 'Beschreibung',
      logo: 'Logo URL',
      editAccount: "Konto bearbeiten",

      // Address fields
      address: {
        street: 'Straße',
        zipCode: 'PLZ',
        city: 'Stadt',
        country: 'Land',
        state: 'Bundesland'
      },

      // Contact fields
      contact: {
        name: 'Kontaktperson',
        email: 'E-Mail',
        phone: 'Telefon',
        fax: 'Fax',
        website: 'Webseite'
      },
      showTenantAccounts: 'Konten anzeigen',
      showTenantCustomers: 'Kunden anzeigen',
      tenantAccounts: 'Mandantenkonten',
      tenantCustomers: 'Mandantenkunden',
      tenantsTableEmpty: 'Keine Mandanten gefunden',
      createAccount: 'Konto erstellen',
      accountCreated: 'Konto erfolgreich erstellt',
      accountCreateError: 'Beim Speichern des Nutzers ist ein Fehler aufgetreten',
      accountsTableEmpty: 'Keine Konten gefunden',
      createCustomer: 'Kunde erstellen',
      customerCreated: 'Kunde erfolgreich erstellt',
      customersTableEmpty: 'Keine Kunden gefunden',
      tenant: {
        name: 'Mandant',
        search: 'Mandanten durchsuchen',
        customerCount: 'Anzahl Kunden',
        accountCount: 'Anzahl Konten',
        activated: 'Mandant aktiviert',
        deactivated: 'Mandant deaktiviert',
      },
      tenantManagement: 'Mandantenverwaltung',
      refresh: 'Aktualisieren',
      deleteTenant: 'Mandant löschen',
      deleteTenantConfirm: 'Mandant löschen bestätigen',
      deleteTenantWarning: 'Sind Sie sicher, dass Sie diesen Mandanten und alle zugehörigen Daten löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      tenantDeleted: 'Mandant erfolgreich gelöscht',
      tenantDeleteFailed: 'Löschen des Mandanten fehlgeschlagen',
      backToTenants: 'Zurück zu Mandanten',
      backToCustomers: 'Zurück zu Kunden',
      active: 'Aktiv',

      searchHint: "Suche nach Name, Domain, E-Mail",
      dateTimeFormat: "DD.MM.YYYY · HH:mm",
      searchAccountHint: "Suche nach Vorname, Nachname, E-Mail, Rolle, Anmeldename",

      account: {
        inactive: 'inaktiv',
        delete: 'Account löschen',
        search: 'Beliebig suchen',
        sendEmail: 'E-Mail senden',
        sendPush: 'Pushnachricht senden',
        resetPushToken: 'Device-Token löschen',
        activated: 'Konto aktiviert',
        deactivated: 'Konto deaktiviert',
        sendTestEmail: 'Test-E-Mail senden',
        sendTestPush: 'Test-Push senden',
        resetAllTokens: 'Alle Tokens zurücksetzen',
        currentUser: "Aktueller Benutzer",
        noActionsPossible: "Keine Aktionen möglich",
        type: 'Typ',
        local: 'Lokal',
        ldap: 'Ldap',
        typeFilter: 'Nach Account-Typ filtern',
        ldapAccounts: 'Ldap Konten',
        localAccounts: 'Lokale Konten',
      },

      customer: {
        search: 'Kunden durchsuchen',
        assign: 'Kunde zuweisen',
        selectToAssign: 'Kunde zum Zuweisen auswählen',
        assignButton: 'Zuweisen',
        assigned: 'Zugewiesene Kunden',
        assignSuccess: 'Kunde erfolgreich zugewiesen',
        removedFromAccount: 'Kunde vom Konto entfernt',
        name: 'Kunden',
        required: 'Kunde erforderlich'
      },

      customerName: 'Kunde',

      globalOverview: 'Globale Übersicht',
      globalCustomers: 'Alle Kunden',
      globalAccounts: 'Alle Konten',
      globalTenants: 'Alle Mandanten',
      tenantEdit: 'Mandant bearbeiten',
      tenants: 'Mandanten',
      customers: 'Kunden',
      accounts: 'Konten',
      viewAll: 'Alle anzeigen',
      recentTenants: 'Neueste Mandanten',
      recentCustomers: 'Neueste Kunden',
      tenantName: 'Mandant',
      view: 'Anzeigen',
      backToDashboard: 'Zurück zur Übersicht',
      backToAccounts: 'Zurück zu Konten',
      createGlobalAccount: 'Globales Konto erstellen',
      accountSection: 'Kontoinformationen',
      accessSection: 'Zugriff & Zuordnung',
      selectTenant: 'Mandant auswählen',
      selectCustomer: 'Kunde auswählen',
      accountActions: 'Kontoaktionen',
      editCustomer: 'Kunde bearbeiten',

      testEmailSent: 'Test-E-Mail gesendet',
      testEmailFailed: 'Senden der Test-E-Mail fehlgeschlagen',
      testPushSent: 'Test-Push-Benachrichtigung gesendet',
      testPushFailed: 'Senden der Test-Push-Benachrichtigung fehlgeschlagen',
      pushTokensReset: 'Push-Tokens zurückgesetzt',
      pushTokensResetFailed: 'Zurücksetzen der Push-Tokens fehlgeschlagen',
      accountUpdated: 'Konto erfolgreich aktualisiert',
      accountDeleted: 'Konto erfolgreich gelöscht',

      accountSectionINFO: 'Account Einstellungen',
      sectionINFO: 'Generelle Einstellungen',
      sectionLDAP: 'LDAP Einstellungen',
      otherCustomer: 'Andere Kunden',
      overview: 'Übersicht',
      ldapTableEmpty: "Keine Daten vorhanden",
      name: 'Name',
      appLoginDomain: 'Login-Domain für lokale Accounts',
      base: 'Benutzer (DN)',
      adminBase: 'Admins (DN)',
      reporterBase: 'Reporter (DN)',
      lastSynchronized: 'Letzte Synchronisierung',
      lastSynchronizedTry: 'Letzter Synchronisierungsversuch',
      nextSynchronizeTry: 'Nächster Synchronisierungsversuch',
      url: 'Server',
      user: 'User',
      domainLogin: 'Login-Domain',
      ldapAccounts: 'LDAP Accounts',
      remoteAccounts: 'Remote Accounts',
      localAccounts: 'Lokale Accounts',
      userCount: 'Synchronisierte Accounts',
      localUserCount: 'Lokale Accounts',
      usersWithTokenCount: 'Aktive Accounts',
      operations: 'Optionen',
      authority: 'Nutzerrecht',
      edit: 'Bearbeiten',
      mail_reception: 'E-Mail Empfang',
      mail: 'E-Mail Verteiler',
      password: 'Passwort',
      save: 'Speichern',
      create: 'Erstellen',
      customerCreate: 'Kunden hinzufügen',
      customerAccounts: 'Accounts',
      syncCustomerAccounts: 'Accounts synchronisieren',
      showCustomerAccounts: 'Accounts anzeigen',
      showCustomerAccountsError: 'wurde nicht synchronisiert.',
      showCustomerAccountsSuccess: 'synchronisiert.',
      createLocalAccount: 'Lokalen Account anlegen',
      deleteCustomer: 'Kunde Löschen',
      deleteCustomerInfoText: 'Der Kunde und alle synchronisierten Accounts werden permanent gelöscht.',
      deleteAccount: 'Account Löschen',
      deleteAccountInfoText: 'Der Account wird unwiderruflich gelöscht. Sind Sie sicher?',
      customerDeleted: 'Kunde gelöscht',
      patchSuccess: 'Speichern erfolgreich',
      genericHttpError: 'Beim Speichern ist ein Fehler aufgetreten, überprüfen Sie die Eingaben und versuchen Sie es erneut.',
      customerExists: 'Ein Kunde mit den angegebenen Parametern existiert bereits',
      defaultCustomer: 'Vorausgewählter Empfänger',
      uniqueCode: 'Eindeutiger Code',
      createdAt: 'Erstellt am',
      updatedAt: 'Zuletzt aktualisiert am',
      status: 'Status',

      logDialog: {
        logButtonTooltip: 'Zeige Server Logs',
        dialogTitle: 'Server Logs',
        refreshButton: 'Refresh Logs',
        automaticIndicator: 'Automatisches Scrolling',
        emptyState: 'Keine Logs vorhanden'
      },
      report_sort: {
        sort_title: 'Sortierung nach',
        TYPE_DATE: 'Meldungstyp',
        CREATED_DATE: 'Erstellung',
        UPDATE_DATE: 'Aktualisierung',
        START_DATE: 'Startdatum'
      },
      notificationSettings: {
        notificationTitle: 'Benachrichtigungen',
        NONE: 'Keine',
        ONLY_DISORDER: 'Nur Störungen',
        ALL: 'Alle'
      }
    }
  }
}
